<div class="wrapper"  *transloco="let t; read: 'statisticComp'">

    <div class="block ion-hide-md-down" [routerLink]="['/student-progress']">

        <div class="img-wrapper">
            <img src="assets/images/student/progress.svg" alt="materials">

            <div class="next">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3F403F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.67461 6.95437C9.88428 6.77465 10.1999 6.79893 10.3796 7.0086L14.3796 11.6753C14.5401 11.8625 14.5401 12.1388 14.3796 12.3261L10.3796 16.9927C10.1999 17.2024 9.88428 17.2267 9.67461 17.047C9.46495 16.8672 9.44067 16.5516 9.62038 16.3419L13.3415 12.0007L9.62038 7.65939C9.44067 7.44973 9.46495 7.13408 9.67461 6.95437Z"
                          fill="white"/>
                </svg>

            </div>

        </div>

        <div class="title">
            {{ t('progress')}}
        </div>


    </div>


    <div class="block-mob ion-hide-md-up">

        <button type="button" class="content-btn grey-btn ion-hide-md-up " [routerLink]="['/student-progress']">
            <div class="content-inner">
                <img src="assets/images/student/progress.svg" alt="laptop">

               {{ t('progress')}}
            </div>
            <div class="arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                          fill="#3F403F"/>
                </svg>

            </div>

        </button>

    </div>


    <div class="block ion-hide-md-down" [routerLink]="['/tests']">

        <div class="img-wrapper">
            <img src="assets/images/student/journal_2.svg" alt="materials">

            <div class="next">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3F403F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.67461 6.95437C9.88428 6.77465 10.1999 6.79893 10.3796 7.0086L14.3796 11.6753C14.5401 11.8625 14.5401 12.1388 14.3796 12.3261L10.3796 16.9927C10.1999 17.2024 9.88428 17.2267 9.67461 17.047C9.46495 16.8672 9.44067 16.5516 9.62038 16.3419L13.3415 12.0007L9.62038 7.65939C9.44067 7.44973 9.46495 7.13408 9.67461 6.95437Z"
                          fill="white"/>
                </svg>

            </div>
        </div>

        <div class="title">
           {{ t('testAndResult')}}
            <ion-badge slot="end" *ngIf="newExam">{{newExam}}</ion-badge>
        </div>


    </div>


    <div class="block-mob ion-hide-md-up">

        <button type="button" class="content-btn grey-btn ion-hide-md-up " [routerLink]="['/tests']">
            <div class="content-inner">
                <img src="assets/images/student/journal_2.svg" alt="materials">

                 {{ t('testAndResult')}}
                <ion-badge slot="end" *ngIf="newExam">{{newExam}}</ion-badge>
            </div>
            <div class="arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                          fill="#3F403F"/>
                </svg>

            </div>

        </button>

    </div>


    <div class="block ion-hide-md-down" [routerLink]="['/certificates']">

        <div class="img-wrapper">
            <img src="assets/images/student/certificate.svg" alt="materials">

            <div class="next">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3F403F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.67461 6.95437C9.88428 6.77465 10.1999 6.79893 10.3796 7.0086L14.3796 11.6753C14.5401 11.8625 14.5401 12.1388 14.3796 12.3261L10.3796 16.9927C10.1999 17.2024 9.88428 17.2267 9.67461 17.047C9.46495 16.8672 9.44067 16.5516 9.62038 16.3419L13.3415 12.0007L9.62038 7.65939C9.44067 7.44973 9.46495 7.13408 9.67461 6.95437Z"
                          fill="white"/>
                </svg>

            </div>
        </div>

        <div class="title">

            {{ t('certificates')}}


        </div>


    </div>

    <div class="block-mob ion-hide-md-up">

        <button type="button" class="content-btn grey-btn ion-hide-md-up " [routerLink]="['/certificates']">
            <div class="content-inner">
                <img src="assets/images/student/certificate.svg" alt="materials">

                {{ t('certificates')}}
            </div>
            <div class="arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                          fill="#3F403F"/>
                </svg>

            </div>

        </button>

    </div>
</div>





